import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { FmlmViewContext } from "../Context/FmlmViewContext";

class FmlmViewInitStep extends StepFlow {
    get stepName() { return "FmlmViewInit_Step"; }

    async onExecute(): Promise<void> {
        console.log("Fmlm View Init step call............")

        let fmlmContext = this.getCtx<FmlmViewContext>("fmlmViewContext");
        if (!fmlmContext) {
            this.setCtx<FmlmViewContext>("fmlmViewContext", new FmlmViewContext());
            fmlmContext = this.getCtx<FmlmViewContext>("fmlmViewContext")!;
        }

        fmlmContext.routeTo = ["FmlmViewInformation_Step", "SelectOfferFlow", "TicketOptionFlow"]

        this.next()
    }

}
export const fmlmViewInitStepDeclaration = new StepDefinition({
    stepName: "FmlmViewInit_Step",
    stepClass: FmlmViewInitStep
});
